import { ShieldAlert } from "lucide-react";
import { S } from "./settlementLabels";

// لوحة الفصل: الموظف مفصول بلا تسوية، والحالة محوّلة للإجراءات القانونية.
export const SettlementDismissed = ({ lang }) => {
  const L = S[lang === "en" ? "en" : "ar"];
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-destructive/30 bg-destructive/5 p-4"
         data-testid="settlement-dismissed">
      <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
      <div>
        <p className="text-sm font-black text-destructive">{L.legalTitle}</p>
        <p className="mt-1 text-xs text-muted-foreground">{L.legalNote}</p>
      </div>
    </div>
  );
};
